/**
 * Created by Ning Jiang on 2021-06-29.
 */

import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {KarenLayers, Layers} from "../view/KarenLayers";
import {Karen} from "../Karen";
import {Translation} from "../../core/utils/Translation";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap, TimelineLite} from "gsap";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {KarenGameAssets} from "../KarenGameAssets";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/text/TextStyleOptions";
import {SpinePlayer} from "../../core/displayObject/SpinePlayer";
import {KarenSoundManager} from "../sound/KarenSoundManager";
import {KarenSoundConfig} from "../sound/KarenSoundConfig";
import {KarenGameConfig} from "../KarenGameConfig";
import {IWinRatioConfig} from "../../core/config/WinRatio";
import {BitMapFont} from "../../core/utils/BitMapFont";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {KarenReelController} from "../reels/KarenReelController";
import {GameHelper} from "../../core/utils/GameHelper";

export class FreespinOutro extends ContinueScreen {

    private _totalWinTxt: PIXI.Text;
    private _played: PIXI.Text;
    private _xWaySize: BitMapFont;
    private _winValue: BitmapCountUp;
    private _outroSpine: SpinePlayer;

    constructor() {
        super(KarenLayers.getLayer(Layers.SCREENS)!);
        const totalWinStyle: TextStyleOptions = {
            "dropShadow": true,
            "dropShadowAngle": 89.6,
            "dropShadowColor": "#fff9ea",
            "fontFamily": "Impact",
            "stroke": "#fff9ea",
            "strokeThickness": 4,
            "fontSize": 55
        };
        const courseStyle: TextStyleOptions = {
            fill: "#1f1811",
            fontFamily: "Impact",
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 40
        };
        this._totalWinTxt = new PIXI.Text("", totalWinStyle);
        const style = {
            fontName: KarenGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 40,
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        };
        this._winValue = new BitmapCountUp(style);
        this._winValue.shrinkSize = true;
        this._played = new PIXI.Text("", courseStyle);
        this._xWaySize = new BitMapFont(KarenGameAssets.BITMAP_FONT_XWAYS, 11);
        this._outroSpine = new SpinePlayer("fs_intro_outro", false);
        this.positionAllGphx();
    }

    public show(onContinueCallBack: () => void): void {
        if (GameHelper.isWinBelowStake()) {
            this._totalWinTxt.visible = false;
        }
        Karen.keypadPlugin.hide();
        const tl: TimelineLite = new TimelineLite();
        Karen.reels.forEach((reel: KarenReelController) => {
            reel.changeReelSet("BASE_REELSET")
        });
        const totalWinRatio = Karen.model.parsedGameData.totalWin / Karen.model.parsedGameData.playedBetValue;
        let skinType: string = GameHelper.getWinRatioLevel(totalWinRatio);
        this._outroSpine.position.set(360, 360);
        let isSoundPlaying: boolean = false;
        let countUpDuration: number = 0.01;
        tl.add(this._outroSpine.play({
            name: "outro_start", loop: false, skinType: skinType, showOnEnd: true, onStart: () => {
                KarenSoundManager.fadeAndStopSound({name: KarenSoundConfig.FREESPIN_WIN_LOOP, to: 0, duration: 100});
                KarenSoundManager.switchMusic({name: KarenSoundConfig.FREESPIN_END_LOOP},
                    {name: KarenSoundConfig.FREESPIN_END_LOOP, to: 100, duration: 100},
                    {name: KarenSoundConfig.FREESPIN_GAME_MUSIC, to: 0, duration: 100});
                KarenSoundManager.fadeFSLoopSound();
            }
        }).add(() =>{
            this._outroSpine.play({
                name: "outro_loop",
                skinType: skinType,
                loop: true,
                showOnEnd: true
            })}));
        tl.add(() => {
            if (!GameHelper.isWinBelowStake()) {
                this._totalWinTxt.visible = true;
                countUpDuration = 0.2;
                isSoundPlaying = true;
            } else {
                countUpDuration = 0.01;
                isSoundPlaying = false;
            }
            this._xWaySize.visible = true;
            this._played.visible = true;
            this._winValue.visible = true;
            if (isSoundPlaying) {
                if (this.getCountUpEndSoundWinRatio() > 1) {
                    KarenSoundManager.playSoundEffect(KarenSoundConfig.COUNTUP, 100);
                }
            }
            this._winValue.getCountUpAnimation(0, Karen.model.parsedGameData.totalWin, countUpDuration, `power3.inOut`);
        }, this._outroSpine.fetchDuration("intro_start") / 2);
        this._container.addChild(this._outroSpine);
        tl.add(() => {
            this.fadeInAllOutroObjects();
        }, (this._outroSpine.fetchDuration("intro_start") / 2) - 0.5);
        this._winValue.getCountUpAnimation(0, 0, 0.01);
        this._totalWinTxt.text = `${Translation.translation("TOTAL WIN")}`;
        const spinPlayed: number = Karen.model.parsedGameData.numberOfFreespinsPlayed;
        const xWaySize: number = Karen.model.parsedGameData.fsXWaysSize;
        this._played.text = `${spinPlayed}`;
        this._xWaySize.text = `${xWaySize}`;
        tl.add(() => {
            if (isSoundPlaying) {
                KarenSoundManager.fadeAndStopSound({
                    name: KarenSoundConfig.COUNTUP,
                    to: 0,
                    duration: 100
                });
                KarenSoundManager.playSoundEffect((<string>(KarenSoundConfig.COUNTUP_ENDS[this.getCountUpEndSoundWinRatio()])));
            }
        }, tl.totalDuration() + 0.2);

        Karen.background.updateBackGround(GameMode.NORMAL);
        super.show(onContinueCallBack);
    }

    protected close(): TimelineLite {
        SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);
        Karen.reel2Frame.updateMode(GameMode.NORMAL); //#182
        KarenSoundManager.playSoundEffect(KarenSoundConfig.MAINGAME_MUSIC_START);
        KarenSoundManager.switchMusic({name: KarenSoundConfig.MAIN_GAME_MUSIC},
            {name: KarenSoundConfig.MAIN_GAME_MUSIC, to: 100, duration: 100},
            {name: KarenSoundConfig.FREESPIN_END_LOOP, to: 0, duration: 100});
        KarenSoundManager.stopSoundEffect(KarenSoundConfig.FREESPIN_GAME_MUSIC);
        KarenSoundManager.stopSoundEffect(KarenSoundConfig.FREESPIN_WIN_LOOP);
        const tl: TimelineLite = gsap.timeline();
        tl.add(gsap.to(this, {duration: 0.2, alpha: 0}));
        tl.add(() => {
            Karen.stickyXWView.hideAllStickyXW();
            Karen.xwaysMultiplierView.hideNoOfWays();
            SlotGame.keypadPlugin.show();
            this._outroSpine.reset();
            this.resetOutroElements();
        });
        return tl;
    }

    private getCountUpEndSoundWinRatio(): number {
        const data = Karen.model.parsedGameData;
        const totalWinRatio = data.totalWin / data.playedBetValue;
        let ratioConfig: IWinRatioConfig;
        for (let i: number = KarenGameConfig.WIN_RATIOS.length - 1; i >= 0; i--) {
            const config = KarenGameConfig.WIN_RATIOS[i];
            if (totalWinRatio >= config.ratio) {
                ratioConfig = config;
                break;
            }
        }
        return ratioConfig!.winRatioIndex!
    }

    private fadeInAllOutroObjects(): void {
        this._container.addChild(this._played);
        this._container.addChild(this._xWaySize);
        this._container.addChild(this._totalWinTxt);
        this._container.addChild(this._winValue);
        this._winValue.alpha = 1;
        this._played.alpha = 1;
        this._xWaySize.alpha = 1;
        this._totalWinTxt.alpha = 1;
    }

    private positionAllGphx(): void {
        this._played.anchor.set(0.5, 0.5);
        this._totalWinTxt.anchor.set(0.5, 0.5);

        this._xWaySize.fontSize = 17;
        this._played.rotation = 0.1;
        this._xWaySize.rotation = 5.95;

        this._played.position.set(610, 251);
        this._xWaySize.position.set(255, 345);
        this._totalWinTxt.position.set(360, 120);
        this._winValue.position.set(360, 190);

        this._totalWinTxt.visible = false;
        this._xWaySize.visible = false;
        this._played.visible = false;
        this._winValue.visible = false;
    }

    private resetOutroElements(): void {
        this._totalWinTxt.alpha = 0;
        this._winValue.alpha = 0;
        this.visible = false;
        this.alpha = 1;
        this._continueButton.visible = false;
    }
}
